module.exports = __webpack_public_path__ + "img/EC_Logo_Colour.bbb69b72.jpg";